import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { StatefulService } from '@services/stateful-service-management/stateful-service-interface/stateful-service-interface';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SpinnerService implements StatefulService {
  /**
   * Shows the app-wide spinner in the AppComponent.
   * Can be used by guards and other services to indicate loading state across the app to prevent a white page.
  */
  showAppWideSpinner$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  reset() {
    this.showAppWideSpinner$.next(false);
  }
}
